import { UserFacade } from '@app/core/app-services';
import * as i0 from "@angular/core";
import * as i1 from "../app-services/user.facade";
var AgeVerifiedGuard = /** @class */ (function () {
    function AgeVerifiedGuard(userFacade) {
        this.userFacade = userFacade;
    }
    AgeVerifiedGuard.prototype.canActivate = function () {
        return this.userFacade.ageOK();
    };
    AgeVerifiedGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AgeVerifiedGuard_Factory() { return new AgeVerifiedGuard(i0.ɵɵinject(i1.UserFacade)); }, token: AgeVerifiedGuard, providedIn: "root" });
    return AgeVerifiedGuard;
}());
export { AgeVerifiedGuard };
